export default __webpack_public_path__ + "static/media/rahul.4108593f.jpeg";